import React, { ReactElement } from 'react';
import { IconProps } from '../../../../types';

const LogoutIcon = ({ className = 'w-6 h-6' }: IconProps): ReactElement => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
  >
    <path
      d="M8.78056 3.59998H5.07468C4.51304 3.59998 3.97441 3.82122 3.57728 4.21505C3.18014 4.60888 2.95703 5.14302 2.95703 5.69998V18.3C2.95703 18.8569 3.18014 19.3911 3.57728 19.7849C3.97441 20.1787 4.51304 20.4 5.07468 20.4H8.78056M9.04375 12H21.0438M21.0438 12L16.4586 7.19998M21.0438 12L16.4586 16.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogoutIcon;
